export const initialEntitlementExceptionsState = {
    countryCode: '00',
    regionCode: '',
    bankHolidaysDeducting: false,
};
